import React, {useEffect, useState} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../_metronic/helpers'
import * as Yup from 'yup'
import useUtils from './useUtils'
import {Formik} from 'formik'
import {useNavigate} from 'react-router-dom'
import AssignConfirmation from '../../modules/alert/AssignConfirmation'

type Props = {
  show: boolean
  handleClose: () => void
  language: any
  setLanguages: any
  limit: any
  offset: any
}
const modalsRoot = document.getElementById('root-modals') || document.body

function EditLanguage({show, handleClose, setLanguages, language, limit, offset}: Props) {
  const {handleEdit} = useUtils()
  const [isOpen, setIsOpen] = useState(false)
  const initialValues = {
    name: language?.name,
    code: language?.code,
  }

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    code: Yup.string().required('Code is required'),
  })

  const handleSubmit = async (values: any) => {
    let res = await handleEdit(values.name, values?.code, language?.id, handleClose)
    setLanguages(res)
  }

  return createPortal(
    <Modal
      id='kt_modal_create_app'
      aria-hidden='true'
      dialogClassName='modal-dialog-centered'
      show={show}
      onHide={handleClose}
    >
      <>
        <div className='modal-header'>
          <h2>Edit Language</h2>
          {/* begin::Close */}
          <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
          {/* end::Close */}
        </div>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({values, errors, touched, handleChange, handleSubmit, setFieldValue}) => (
            <form className='form' onSubmit={handleSubmit}>
              <div className='modal-body px-lg-10'>
                <div className='tab-content'>
                  {/* end::Body */}
                  <div className='row align-items-center flex-wrap'>
                    <div className='col'>
                      <label className='col-form-label required fw-bold fs-6'>Name</label>
                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid  mb-lg-0'
                        placeholder='name'
                        name='name'
                        value={values.name}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className='row align-items-center flex-wrap mt-2'>
                    <div className='col-lg-6'>
                      <label className='col-form-label required fw-bold fs-6'>Code</label>
                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                        placeholder='Code'
                        name='code'
                        value={values.code}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className='d-flex align-items-center  justify-content-end mt-7'>
                  <button type='button' className='btn btn-danger ms-2 me-2' onClick={handleClose}>
                    Cancel
                  </button>
                  <button
                    type='button'
                    onClick={() => {
                     setIsOpen(true)
                    }}
                    className='btn btn-primary ms-2 me-2'
                  >
                    Update
                  </button>
                </div>
              </div>
            </form>
          )}
        </Formik>
        <AssignConfirmation
          isVisible={isOpen}
          message='Are you sure you want to update this language?'
          onConfirm={() => {
            setIsOpen(false)
            setTimeout(() => {
              document.querySelector('form')?.requestSubmit() // Triggers form submission
            }, 0)
          }}
          onCancel={() => setIsOpen(false)}
        />
      </>
    </Modal>,
    modalsRoot
  )
}

export default EditLanguage
